import { Header } from '@components/Header'
import * as Sentry from '@sentry/browser'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useRouteError } from 'react-router-dom'

import { ErrorRobot } from '@/components/icons/ErrorRobot'

export const Error = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const error = useRouteError()

  useEffect(() => {
    if (!error) return

    Sentry.captureException(error, {
      contexts: {
        Error: {
          ...error
        }
      }
    })
  }, [error])

  return (
    <div className="flex min-h-full w-full flex-col items-center justify-center sm:p-4">
      <div className="flex h-full w-full max-w-[640px] grow flex-col overflow-clip sm:rounded-lg sm:shadow-strong">
        <Header />

        <div className="flex flex-col items-center gap-10 p-6">
          <p className="text-primary">{t('something_went_wrong')}</p>
          <ErrorRobot />

          <button
            className={`h-15 w-full rounded-md bg-primary text-base font-bold uppercase text-white shadow-strong disabled:opacity-50`}
            onClick={() => {
              // check if current slug is /error
              const currentSlug = window.location.pathname
              if (currentSlug === '/error') {
                navigate(-1)
              } else {
                window.location.reload()
              }
            }}
          >
            {t('try_again')}
          </button>
        </div>
      </div>
    </div>
  )
}
